import {FC, createContext, useContext, useState, PropsWithChildren} from 'react'

export interface ListViewContextProps {
  selected: number[]
  setSelected: (selected: number[]) => void
  itemIdForUpdate?: number
  setItemIdForUpdate: (id?: number) => void
}

const ListViewContext = createContext<ListViewContextProps>({
  selected: [],
  setSelected: () => {},
  itemIdForUpdate: undefined,
  setItemIdForUpdate: () => {},
})

const ListViewProvider: FC<PropsWithChildren<{}>> = ({children}) => {
  const [selected, setSelected] = useState<number[]>([])
  const [itemIdForUpdate, setItemIdForUpdate] = useState<number>()

  return (
    <ListViewContext.Provider value={{selected, setSelected, itemIdForUpdate, setItemIdForUpdate}}>
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView} 